import { render } from "./DepartmentDesktop.vue?vue&type=template&id=031b3fc0&scoped=true"
import script from "./DepartmentDesktop.vue?vue&type=script&lang=js"
export * from "./DepartmentDesktop.vue?vue&type=script&lang=js"

import "./DepartmentDesktop.vue?vue&type=style&index=0&id=031b3fc0&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031b3fc0"]])

export default __exports__